<div class="profile-container" *ngIf="userProfile$ | async as profile">
  <div class="profile-header">
    <div class="avatar-container" [class.editable]="canEdit$ | async" (click)="openFilePicker()">
      <img [src]="environment.backend + profile.profilePictureUrl" *ngIf="profile.profilePictureUrl" alt="Profilbild" />
      <div class="avatar-placeholder" *ngIf="!profile.profilePictureUrl">
        <mat-icon>person</mat-icon>
      </div>
      <div class="upload-overlay">
        <mat-icon>edit</mat-icon>
        <span>Profilbild ändern</span>
      </div>
      <input type="file" #fileInput hidden (change)="onFileSelected($event)" />
    </div>

    <div class="user-info">
      <div class="name-line">
        <h1>{{ profile.username }}</h1>
        @if (!(isHandset$ | async) && profile.badges && profile.badges.length > 0) {
          <div class="badges-inline">
            @for (badge of profile.badges; track badge.badgeKey) {
              <div class="badge-small" [matTooltip]="badge.description">
                <mat-icon [color]="badge.badgeKey === 'ADMIN' ? 'primary' : ''">{{ badge.iconName }}</mat-icon>
              </div>
            }
          </div>
        }
      </div>
      <p>Registriert seit: {{ profile.createdAt | date: 'dd.MM.yyyy' }}</p>
      @if (profile._nextLevelTotalXp != null && profile._xpToNextLevel != null) {
        <div
          class="xp-progress"
          [matTooltip]="'Noch ' + profile._xpToNextLevel + ' XP bis Level ' + ((profile.level ?? 0) + 1)"
        >
          <div class="xp-label">
            <span>Level {{ profile.level ?? 0 }}</span>
            <span class="xp-values">
              {{ profile._nextLevelTotalXp - profile._xpToNextLevel }} / {{ profile._nextLevelTotalXp }} XP
            </span>
          </div>
          <mat-progress-bar
            mode="determinate"
            color="primary"
            [value]="((profile._nextLevelTotalXp - profile._xpToNextLevel) / (profile._nextLevelTotalXp || 1)) * 100"
          >
          </mat-progress-bar>
        </div>
      }
    </div>
  </div>

  @if ((isHandset$ | async) && profile.badges && profile.badges.length > 0) {
    <div class="mobile-badges">
      @for (badge of profile.badges; track badge.badgeKey) {
        <div class="badge-small" [matTooltip]="badge.name + ': ' + badge.description">
          <mat-icon [color]="badge.badgeKey === 'ADMIN' ? 'primary' : ''">{{ badge.iconName }}</mat-icon>
        </div>
      }
    </div>
  }

  <mat-grid-list [cols]="1" gutterSize="24px" rowHeight="400px">
    <mat-grid-tile>
      <mat-card class="widget-card">
        <mat-card-title>Verfasste Bewertungen</mat-card-title>
        <mat-card-content>
          <mat-list *ngIf="userReviews$ | async as reviews">
            @for (review of reviews; track review.id) {
              @if (review.comment) {
                <mat-list-item>
                  <mat-icon matListItemIcon>rate_review</mat-icon>
                  <div matListItemTitle>"{{ review.comment }}"</div>

                  <div matListItemLine class="line-wrap">
                    <span
                      >für
                      <span class="navlink" (click)="toMap(review._restStop!)">{{ review.restStopName }}</span></span
                    >
                    <span class="date">{{ review.createdAt | date: 'dd.MM.yyyy' }}</span>
                  </div>
                </mat-list-item>
              }

              <mat-divider></mat-divider>
            } @empty {
              <p class="empty-state">Dieser Benutzer hat noch keine Bewertungen geschrieben.</p>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
